<template>
    <div class="container">
      <div class="box">
        <h2>{{ t('auth.forgot.title') }}</h2>
        <template v-if="!sent">
          <input
            v-model="email"
            :placeholder="t('auth.forgot.email_placeholder')"
            class="input"
          />
          <button @click="submit" class="button">
            {{ t('auth.forgot.submit') }}
          </button>
        </template>
        <p v-if="message" class="message">{{ message }}</p>
      </div>
    </div>
  </template>
  
  
  <script setup>
  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import { useI18n } from 'vue-i18n'
  import axios from 'axios'
  
  const { t } = useI18n()
  const email = ref('')
  const message = ref('')
  const sent = ref(false)
  const router = useRouter()
  
  onMounted(() => {
    const token = localStorage.getItem('token')
    if (token) {
      router.push('/')
    }
  })
  
  const submit = async () => {
    try {
      const res = await axios.post('/auth/forgot-password', {
        e_mail: email.value,
      })
      message.value = res.data.message
      sent.value = true
    } catch (err) {
      message.value = t('auth.forgot.error')
    }
  }
  
  </script>
  
  <style scoped> 
  
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
  
  .box {
    background-color: #050505;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);
    max-width: 400px;
    width: 100%;
    color: #ffffff;
  }
  
  h2 {
    font-size: 1rem;
    margin-bottom: 1rem;
    font-weight: 500;
  }
  
  .input {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 1rem; 
  }
  
  .input::placeholder {
    color: #aaa;
  }
  
  .button {
    width: 100%;
    padding: 0.5rem;
    background-color: #023032;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .button:hover {
    background-color: #065959;
  }
  
  .message {
    margin-top: 1rem;
    color: #22c55e;
  }
  </style>
  